import { render, staticRenderFns } from "./IsLeaveBeforeSinisterQuestion.vue?vue&type=template&id=0c26c66b&scoped=true"
import script from "./IsLeaveBeforeSinisterQuestion.vue?vue&type=script&lang=ts"
export * from "./IsLeaveBeforeSinisterQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c26c66b",
  null
  
)

export default component.exports